// ============================================
// SETTINGS DIALOG COMPONENT
// POS Settings configuration dialog
// Extracted from POSPageV2.jsx
// ============================================

import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Label } from '../ui/label';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '../ui/select';
import { Settings } from 'lucide-react';

const SettingsDialog = ({
    open,
    onOpenChange,
    posSettings,
    setPosSettings,
}) => {
    const updateSetting = (key, value) => {
        setPosSettings(prev => ({ ...prev, [key]: value }));
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Settings className="w-5 h-5" />
                        Paramètres Caisse
                    </DialogTitle>
                </DialogHeader>
                <div className="py-4 space-y-4">
                    {/* Manager Mode */}
                    <div className="flex items-center justify-between p-3 border rounded-lg">
                        <div>
                            <p className="font-medium">Mode Manager</p>
                            <p className="text-xs text-muted-foreground">Activer pour Admin/Directeur</p>
                        </div>
                        <Switch
                            checked={posSettings.managerModeEnabled}
                            onCheckedChange={(v) => updateSetting('managerModeEnabled', v)}
                        />
                    </div>
                    
                    {/* Fast Service */}
                    <div className="flex items-center justify-between p-3 border rounded-lg">
                        <div>
                            <p className="font-medium">Service Rapide</p>
                            <p className="text-xs text-muted-foreground">1 clic = ajout direct</p>
                        </div>
                        <Switch
                            checked={posSettings.fastServiceEnabled}
                            onCheckedChange={(v) => updateSetting('fastServiceEnabled', v)}
                        />
                    </div>
                    
                    {/* Kitchen Send Mode */}
                    <div className="p-3 border rounded-lg">
                        <Label className="mb-2 block">Envoi cuisine</Label>
                        <Select
                            value={posSettings.kitchenSendMode}
                            onValueChange={(v) => updateSetting('kitchenSendMode', v)}
                        >
                            <SelectTrigger>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="button">Au clic "Cuisine"</SelectItem>
                                <SelectItem value="payment">Au paiement</SelectItem>
                                <SelectItem value="auto_add">Auto (chaque ajout)</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                    
                    {/* Table Required */}
                    <div className="flex items-center justify-between p-3 border rounded-lg">
                        <div>
                            <p className="font-medium">Table obligatoire</p>
                            <p className="text-xs text-muted-foreground">Pour service sur place</p>
                        </div>
                        <Switch
                            checked={posSettings.tableRequired}
                            onCheckedChange={(v) => updateSetting('tableRequired', v)}
                        />
                    </div>
                    
                    {/* Popular Mode */}
                    <div className="p-3 border rounded-lg">
                        <Label className="mb-2 block">Produits populaires</Label>
                        <Select
                            value={posSettings.popularMode}
                            onValueChange={(v) => updateSetting('popularMode', v)}
                        >
                            <SelectTrigger>
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="auto">Automatique (14j)</SelectItem>
                                <SelectItem value="manual">Manuel</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </div>
                <DialogFooter>
                    <Button onClick={() => onOpenChange(false)}>
                        Fermer
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default SettingsDialog;
